import { render, staticRenderFns } from "./simulator-portfolio-table.vue?vue&type=template&id=36686439&scoped=true&"
import script from "./simulator-portfolio-table.vue?vue&type=script&lang=js&"
export * from "./simulator-portfolio-table.vue?vue&type=script&lang=js&"
import style0 from "./simulator-portfolio-table.vue?vue&type=style&index=0&id=36686439&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36686439",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VHover } from 'vuetify/lib/components/VHover';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VHover,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36686439')) {
      api.createRecord('36686439', component.options)
    } else {
      api.reload('36686439', component.options)
    }
    module.hot.accept("./simulator-portfolio-table.vue?vue&type=template&id=36686439&scoped=true&", function () {
      api.rerender('36686439', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/portfolio-review/components/simulator-portfolio-table/simulator-portfolio-table.vue"
export default component.exports